var tabs = jQuery('.product__info-wrapper ul.tabs');
if( tabs.length > 0 ){
    tabs.each(function(i) {
        var tab = jQuery(this).find('> li > a');
        tab.click(function(e) {
            var contentLocation = jQuery(this).attr('href');
            if (contentLocation.charAt(0) == "#") {
                e.preventDefault();
                tab.removeClass('active');
                jQuery(this).addClass('active');
                jQuery(this).parents('ul.tabs').next().find(contentLocation).show().css({
                    'display': 'block'
                }).addClass('active').siblings().hide().removeClass('active');
            }
        });
    });
}
